import { CouponData } from "../../models/interfaces/coupons.interface";

export const MOCK_COUPONS: CouponData[] = [
  {
    id: "hellofresh",
    attribute: "Hello Fresh",
    cpaRate: 0,
    promoVoucher: "GLOSSFRESH",
    approvedCopyShort: [
      "HelloFresh delivers delicious recipes and fresh, seasonal ingredients to your door every week, so you can cook wholesome and satisfying meals everyone will love.",
    ],
    approvedCopyMedium: [
      "HelloFresh delivers fresh, seasonal ingredients and delicious recipes to your door every week, so you can cook wholesome and satisfying meals everyone will love. We take care of all the meal planning and grocery shopping so you can relax knowing dinner is sorted!",
    ],
    approvedCopyLong: [
      "HelloFresh delivers fresh, seasonal ingredients and delicious recipes to your door every week, so you can cook wholesome and satisfying meals everyone will love. Whether you're cooking for two or feeding the whole family, there's a flexible plan to suit your lifestyle. From adventurous recipes inspired by global cuisine to quick and easy classics, you can build your perfect weekly menu.",
    ],
    offerOnPopup: "Get up to $240 off your first 6 boxes",
    OfferOnCard: "Up to $240 off first 6 boxes",
    termsAndConditions: [
      "This voucher entitles you to up to: $75 off your first box (including standard delivery), $35 off your second box, $25 off your third & fourth boxes respectively, $35 off your fifth box and $45 off your sixth box, subject to the voucher being utilised within 72 days of your subscription. ",
      "Total promotional value of up to $240 based on largest box size, 5 meals for 4 people.",
      "Offer only valid for new customers and past customers (cancelled for over 6 months).",
      "Discount is non-transferable, non-exchangeable, excludes upgrades, add-ons and is invalid in conjunction with any other offer.",
      "By using this voucher, you will be signed up to an ongoing weekly subscription.",
    ],
    url: "https://www.hellofresh.com.au/pages/inspiration-delivered?c=GLOSSFRESH&discount_comm_id=8c02a3cl-ec40-4740-bc20-dff29d2abf16",
    logoSvg: "hello-fresh-logo",
  },
  {
    id: "everyplate",
    attribute: "Every Plate",
    cpaRate: 0,
    promoVoucher: "GLOSSPLATE",
    approvedCopyShort: [
      "EveryPlate delivers tasty recipes and quality ingredients each week, so you can cook budget-smart, fuss-free dinners the whole household will love.",
    ],
    approvedCopyMedium: [
      "With EveryPlate, you can cook budget-smart, fuss-free dinners the whole household will love. Each box is packed with quality, pre-portioned ingredients and four-step recipes, so you can cook tasty, familiar favourites in as little as 15 minutes.",
    ],
    approvedCopyLong: [
      "With EveryPlate, you can cook budget-smart, fuss-free dinners the whole household will love. Each box is packed with quality, pre-portioned ingredients and four-step recipes, so you can cook tasty, familiar favourites in as little as 15 minutes. The best part is, it's cheaper than the supermarket!",
    ],
    offerOnPopup: "Get 40% off your first box + up to 20% off for a month",
    OfferOnCard: "40% off first box + 20% monthly",
    termsAndConditions: [
      "Valid for new customers and past customers (cancelled for over 12 months) only.",
      "Get 40% off your first box (including free shipping), and 20% off your second, third, fourth and fifth boxes respectively.",
      "Offer must be used within 42 days of your date of sign up.",
      "Offers not applicable for add ons or surcharges and cannot be combined with gift cards or any other promotion.",
      "Valid for customers residing in Australia only.",
      "Offers are not transferable or redeemable for cash.",
      "EveryPlate may terminate, withdraw or modify the offer at any time.",
      "Full T&Cs at https://www.everyplate.com.au/terms.",
    ],
    url: "https://www.everyplate.com.au/plans?c=GLOSSPLATE&discount_comm_id=780f03el-a5b6-4b8b-bc6f-d7f3bc4ba233",
    logoSvg: "everyplate-logo",
  },
  {
    id: "youfoodz",
    attribute: "YouFoodz",
    cpaRate: 0,
    promoVoucher: "GLOSSFOODZ",
    approvedCopyShort: [
      "Fresh, chef-prepared meals delivered right to your door, making healthy eating effortless.",
    ],
    approvedCopyMedium: [
      "Skip the cooking and cleaning with Youfoodz' delicious range of ready-made meals. Fuel your busy lifestyle with fresh, healthy dishes designed for maximum flavour and minimal effort.",
    ],
    approvedCopyLong: [
      "Struggling to find time for healthy cooking? Say goodbye to meal prep stress and hello to Youfoodz. Enjoy a diverse menu of delicious, chef-prepared meals made with quality ingredients and delivered fresh across Australia. It's the easiest way to stay on track with your health goals without sacrificing taste or convenience.",
    ],
    offerOnPopup: "Get up to 40% off your first 13 boxes",
    OfferOnCard: "Up to 40% off first 13 boxes",
    termsAndConditions: [
      "This voucher entitles you to up to: 40% off your first box, 30% off your second box, 20% off your third & 10% off your fourth to tenth boxes.",
      "Offer only valid for new customers and past customers (cancelled for over 12 months).",
      "Discount is non-transferable, non-exchangeable, excludes upgrades, add-ons and is invalid in conjunction with any other offer.",
      "By using this voucher, you will be signed up to an ongoing weekly subscription.",
    ],
    url: "https://www.youfoodz.com.au/?c=GLOSSFOODZ&discount_comm_id=9d13b4dm-fd51-4851-cd31-e8g4cd5cb344",
    logoSvg: "youfoodz-logo",
  },
  {
    id: "nordvpn",
    attribute: "NordVPN",
    approvedCopyShort: ["Smart choices deserve a reward!"],
    offerOnPopup: "Get up to 73% off NordVPN + an Amazon Gift Card",
    OfferOnCard: "Up to 73% off + Amazon Gift Card",
    url: "https://nordvpn.com/pricing/",
    logoSvg: "nordvpn-logo",
    uniqueTrackingLink: ["https://go.nordvpn.net/aff_c?offer_id=15&aff_id=140958&url_id=902"],
    buttontext: "Visit NordVPN",
  },
  {
    id: "macpaw",
    attribute: "MacPaw",
    offerOnPopup: "Save 15% on CleanMyMac",
    OfferOnCard: "15% off CleanMyMac",
    approvedCopyShort: ["Clean junk, remove malware, and optimize your Mac in minutes."],
    url: "https://macpaw.audw.net/c/7031516/3804232/1733",
    logoSvg: "macpaw-logo",
    uniqueTrackingLink: ["https://macpaw.audw.net/c/7031516/66209/1733"],
    buttontext: "Visit CleanMyMac",
  },
  {
    id: "surfsharkvpn",
    attribute: "Surfshark VPN",
    cpaRate: 0.4,
    offerOnPopup: "Up to 4 extra months and are fully refundable within 30 days",
    OfferOnCard: "Up to 4 extra months free",
    approvedCopyShort: [
      "The ultimate value VPN bundle. Enjoy unlimited device connections, ad blocker, and more with a 30-day money-back guarantee!",
    ],
    logoSvg: "surfshark-logo",
    uniqueTrackingLink: [
      "https://get.surfshark.net/aff_c?offer_id=926&aff_id=45015",
      "https://get.surfshark.net/aff_c?offer_id=934&aff_id=45015",
      "https://get.surfshark.net/aff_c?offer_id=1498&aff_id=45015",
    ],
    uniqueTrackingLabels: ["VPN", "Antivirus", "Adblock"],
    buttontext: "Visit Website",
  },
  {
    id: "ticombo",
    attribute: "Ticombo",
    offerOnPopup: "Buy & Sell Tickets Securely",
    OfferOnCard: "Buy & Sell Tickets Securely",
    approvedCopyShort: [
      "Ticombo is the Fair, Easy & Safe place for tickets. Ticombo is the world's biggest marketplace with over 1 million Facebook Followers.",
    ],
    approvedCopyLong: [
      "Options",
      "1. Buy & Sell Tickets Securely",
      "2. Tickets for Live Events Worldwide",
      "3. World Cup 2026 Tickets & More",

      "Description",
      "a. Secure tickets for sports, concerts & theatre worldwide, backed by TixProtect buyer protection.",
      "b. Buy and sell tickets safely worldwide. Trusted marketplace with buyer protection and 24/7 support.",
      "c. Find tickets to top sports and live events worldwide. Transparent pricing and buyer protection included.",
    ],
    url: "https://www.ticombo.com/en",
    uniqueTrackingLink: ["https://www.affiliatesticombo.com/"],
    logoSvg: "ticombo-logo",
    buttontext: "Visit Ticombo",
  },
  {
    id: "experienceoz",
    attribute: "Experience Oz",
    url: "https://glossvault.experienceoz.com.au/en?utm_source=website&utm_medium=text+link&utm_campaign=glossvault",
    offerOnPopup: "Exclusive 10% discount",
    OfferOnCard: "Exclusive 10% discount",
    approvedCopyShort: [
      "Experience Oz provides over 4,000 experiences and access to some of the best deals in the market.",
    ],
    termsAndConditions: [
      "Select the link above to apply an additional 10% discount to the existing offers on Experience Oz",
    ],
    logoSvg: "exoz-logo",
  },
  {
    id: "illumi",
    attribute: "Illumi",
    url: "https://www.illumi.one/",
    offerOnPopup: "Exclusive 10% discount",
    OfferOnCard: "Exclusive 10% discount",
    approvedCopyShort: [
      "Turn your creative thinking into structured, publish-ready output with AI on a collaborative canvas.",
    ],
    logoSvg: "illumi-logo",
    promoVoucher: "GLOSSVAULT10OFF",
  },
  {
    id: "olssons",
    attribute: "Olsson's",
    url: "https://olssons.com.au/collections/all-products",
    offerOnPopup: "10% off across the online store",
    OfferOnCard: "10% off across the online store",
    approvedCopyShort: [
      "Pure Australian sea salt, solar-evaporated and family-owned since 1948. For cooking, finishing and gifting.",
    ],
    logoSvg: "olssons-logo",
    promoVoucher: "GLOSSVAULT",
    termsAndConditions: [
      "Use the code at checkout.",
      "10% off across the online store.",
      "Valid for all customers.",
      "No minimum purchase requirement.",
      "No usage limits.",
      "Cannot be combined with other discounts.",
    ],
  },
  {
    id: "silkbonnetworldaustralia",
    attribute: "Silk Bonnet World Australia",
    url: "https://silkbonnetworld.com.au/",
    OfferOnCard: "10% off",
    offerOnPopup: "10% off",
    approvedCopyShort: [
      "Shop silk bonnets, pillowcases, and sleep essentials for smoother hair and better mornings.",
    ],
    logoSvg: "silk-bonnet-world-logo",
    promoVoucher: "GLOSSVAULT",
  },
  {
    id: "binge",
    attribute: "BINGE",
    url: "https://trybinge.tv/",
    offerOnPopup: "7-day free trial",
    OfferOnCard: "7-day free trial",
    approvedCopyShort: [
      "Enjoy a 7-day free trial on TryBinge.tv with hundreds of documentaries, thrillers, and more!",
    ],
    logoSvg: "binge-logo",
  },
  {
    id: "oliveoilskincare",
    attribute: "Olive Oil Skincare",
    url: "https://oliveoilskincare.com.au/",
    promoVoucher: "Vault30",
    offerOnPopup: "30% off orders over $75 AUD",
    OfferOnCard: "30% off orders over $75 AUD",
    approvedCopyShort: [
      "Olive Oil Skincare; utilising olive oil as the core ingredient in an extensive range of all-natural, environmentally sustainable skin care suitable for all the family. Made in Australia, for Australians, by Australians. Supporting Australian businesses.",
    ],
    logoSvg: "olive-oil-skincare-logo",
  },
  {
    id: "australiangourmetgifts",
    attribute: "Australian Gourmet Gifts",
    url: "https://www.australiangourmetgifts.com.au/",
    offerOnPopup: "15% off Australian Gourmet Gifts",
    OfferOnCard: "15% off Australian Gourmet Gifts",
    approvedCopyShort: [
      "Premium gift hampers for every occasion, beautifully packed and delivered Australia-wide.",
    ],
    logoSvg: "australiangourmetgifts-logo",
    promoVoucher: "GLOSS15",
  },
  {
    id: "alessandroluppolochocolate",
    attribute: "Alessandro Luppolo Chocolate",
    url: "https://alessandroluppolo.com/",
    offerOnPopup: "10% off with code below",
    OfferOnCard: "10% off",
    promoVoucher: "GLOSS10",
    approvedCopyShort: [
      "Handmade Melbourne chocolate. Bean-to-bar chocolate from our Elsternwick workshop.",
    ],
    logoSvg: "alessandro-luppolo-chocolate-logo",
    termsAndConditions: [
      "10% off online and in-store when they mention or enter GLOSS10",
      "One use per customer",
      "Not combined with other offers",
    ],
  },
];
